package com.arenaproplay.admin.ui.utils

import kotlin.js.Date

/**
 * Render an ISO-8601 timestamp as `DD MMM YYYY · HH:MM` in UTC+2 (Kyiv).
 * Falls back to the raw string if parsing fails. Designed for admin tables
 * where space is tight and locale-aware formatting would be noise.
 */
fun formatTimestamp(iso: String?): String {
    if (iso.isNullOrBlank() || iso == "—") return iso ?: "—"
    val millis = Date.parse(iso)
    if (millis.isNaN()) return iso

    val d = Date(millis)
    val months = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

    val h = ((d.getUTCHours() + 2) % 24).toString().padStart(2, '0')
    val m = d.getUTCMinutes().toString().padStart(2, '0')
    val day = d.getUTCDate().toString().padStart(2, '0')
    val mon = months[d.getUTCMonth()]
    val year = d.getUTCFullYear()

    return "$day $mon $year · $h:$m"
}

/**
 * Short relative-ish render — only date + time, no year if it's the current one.
 * Useful for dense rows where the date repeats often.
 */
fun formatTimestampShort(iso: String?): String {
    if (iso.isNullOrBlank() || iso == "—") return iso ?: "—"
    val millis = Date.parse(iso)
    if (millis.isNaN()) return iso

    val d = Date(millis)
    val now = Date()
    val months = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

    val h = ((d.getUTCHours() + 2) % 24).toString().padStart(2, '0')
    val m = d.getUTCMinutes().toString().padStart(2, '0')
    val day = d.getUTCDate().toString().padStart(2, '0')
    val mon = months[d.getUTCMonth()]

    return if (d.getUTCFullYear() == now.getUTCFullYear()) {
        "$day $mon · $h:$m"
    } else {
        "$day $mon ${d.getUTCFullYear()} · $h:$m"
    }
}
